import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { OPERATIONAL_CATEGORY_ROWS } from "@/lib/budgetCategories";

// Fixed-row category editor used exclusively by Operational Requests.
// Instead of the free-form line editor, Finance picks amounts against a
// preset list of expense categories. The "Other" row accepts a free-text
// description so miscellaneous spend still has a label on the printed form.
export function OperationalCategoryEditor({ value, onChange }) {
  const map = value || {};

  function update(key, patch) {
    onChange({ ...map, [key]: { ...(map[key] || { amount: 0, description: "" }), ...patch } });
  }

  const total = OPERATIONAL_CATEGORY_ROWS.reduce(
    (s, r) => s + (Number(map[r.key]?.amount) || 0), 0,
  );

  return (
    <div className="space-y-2">
      <Label className="text-xs uppercase tracking-widest text-muted-foreground">Categories</Label>
      <div className="border border-border rounded-md overflow-hidden">
        <div className="grid grid-cols-[1.4fr_1.6fr_140px] gap-2 px-3 py-2 bg-muted text-[11px] uppercase tracking-widest text-muted-foreground">
          <div>Category</div>
          <div>Description</div>
          <div className="text-right">Amount (₱)</div>
        </div>
        {OPERATIONAL_CATEGORY_ROWS.map((row) => {
          const cell = map[row.key] || { amount: 0, description: "" };
          const isOther = row.key === "other";
          return (
            <div
              key={row.key}
              className="grid grid-cols-[1.4fr_1.6fr_140px] gap-2 px-3 py-2 border-t border-border items-center"
            >
              <div className="text-sm">{row.label}</div>
              {isOther ? (
                <Input
                  value={cell.description || ""}
                  onChange={(e) => update(row.key, { description: e.target.value })}
                  placeholder="Describe the miscellaneous expense"
                  className="h-8 border-border"
                  data-testid={`op-cat-desc-${row.key}`}
                />
              ) : (
                <div className="text-xs text-muted-foreground">
                  {row.sub_category ? "" : "—"}
                </div>
              )}
              <Input
                type="number"
                min="0"
                step="0.01"
                value={cell.amount || ""}
                onChange={(e) => update(row.key, { amount: Number(e.target.value) })}
                placeholder="0.00"
                className="h-8 tabular-nums text-right border-border"
                data-testid={`op-cat-amount-${row.key}`}
              />
            </div>
          );
        })}
        <div className="grid grid-cols-[1.4fr_1.6fr_140px] gap-2 px-3 py-2 border-t border-border bg-muted/40">
          <div className="col-span-2 text-right text-xs uppercase tracking-widest text-muted-foreground">Total</div>
          <div
            className="text-right font-heading font-bold tabular-nums"
            data-testid="op-cat-total"
          >
            {total.toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </div>
        </div>
      </div>
    </div>
  );
}
